(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('StoredDocumentStats', StoredDocumentStats);

    StoredDocumentStats.$inject = ['$http'];

    function StoredDocumentStats($http) {
        return {
            getAll: function() {
                return $http.get('api/admin/stored-document-stats');
            }
        };
    }
})();
